
import Component from "../component";
import thematics from "../../../data/thematic";
import buildings from "../../../data/buildings";
import { getLocale, getLabel } from '../../helpers/locale';
import { getConfig } from "configuration/config";
import { isMobileView } from "../../utils/utils";
export interface IThematicComponent {
    thematics?: JSON;
    query?: string;
    showDescription?: boolean;
    loadFavorites?: boolean
}
export enum ThematicComponentEvents {
    THEMATIC_SELECTED = "thematic_selected",
    LANGUAGE_CHANGED = "language_changed",
    BUILDING_SELECTED = "building_selected",
    ALL_EXHIBITS_SELECTED = "all_exhibits_selected",
    FAVORITES_SELECTED = "favorites",
    THEMATIC_UNSELECTED = "thematic_unselected"
}
export default class ThematicComponent extends Component<IThematicComponent> {
    public defaultTheme!: any;
    public selectedBuilding!: any;
    init(): void {
        this.renderThematics();
        const $btnAllExhibits = document.getElementById("btnAllExhibits") as HTMLButtonElement;
        const $btnFavorites = document.getElementById("btnFavorites") as HTMLButtonElement;
        if ($btnAllExhibits) {
            $btnAllExhibits.textContent = isMobileView() ? getLocale().messages.allexhibits_mobile : getLocale().messages.allexhibits;
            $btnAllExhibits.addEventListener("click", () => {
                this.switchMap('all');
            });
        }
        if ($btnFavorites) {
            $btnFavorites.textContent = isMobileView() ? getLocale().messages.favorites_mobile : getLocale().messages.favorites;
            $btnFavorites.addEventListener("click", () => {
                $btnFavorites.classList.add("active");
                this.switchMap('favorites');
            });
        }
        this.renderBuildings(this.defaultTheme && this.defaultTheme.ref);
    }
    render(): void {

    }
    renderThematics(): void {
        const jsonData = thematics["thematics"];

        const container = document.getElementById("thematicDropdown");
        const chooseTitle = document.getElementsByClassName("thematic-selector-title");
        const $btnThematic = document.getElementById("btnThematic") as HTMLButtonElement;
        if (chooseTitle && chooseTitle[0]) {
            chooseTitle[0].innerHTML = isMobileView() ? getLocale().messages.select_thematic_mobile : getLocale().messages.choose_thematic;
        }
        if($btnThematic) {
            $btnThematic.innerHTML = `${isMobileView() ? getLocale().messages.select_thematic_mobile : getLocale().messages.select_thematic} <span class="caret"></span>`;
        }
        if (container) {
            container.innerHTML = '';
            jsonData.forEach((item) => {
                const $dropdownElem = document.createElement("a");

                $dropdownElem.tabIndex = 1;
                $dropdownElem.setAttribute("data-id", item["ref"].toString());
                const ref = item["ref"];
                $dropdownElem.textContent = getLabel(getLocale().thematics, ref);
                if (this.state.query && this.state.query !== "" && this.state.query.includes('thematic')) {
                    const selectedTheme = this.state.query?.split('=')[1] || '';
                    if (selectedTheme.toLowerCase() === ref.toLowerCase()) {
                        this.defaultTheme = item;
                    }
                }
                $dropdownElem.onclick = () => {
                    this.resetClasses();
                    const filter = `thematic:=${item["ref"].replace(' ', '').toLowerCase()}`;
                    this.emit(ThematicComponentEvents.THEMATIC_SELECTED, filter);
                    this.renderBuildings(item["ref"].replace(' ', '').toLowerCase());
                    if($btnThematic){
                        $btnThematic.innerHTML = `${getLabel(getLocale().thematics, ref)} <span class="caret"></span>`;
                        $btnThematic.classList.add("active");
                    }
                    container.querySelectorAll("a").forEach(option => {
                        option.classList.remove("selected-thematic");
                        option.classList.add("unselected-thematic");
                    });
                    $dropdownElem.classList.remove("unselected-thematic");
                    $dropdownElem.classList.add('selected-thematic');  
                    this.selectThematic(item)
                };
                container.appendChild($dropdownElem);

            });
        } else {
            console.error("Container not found");
        }
        if (this.defaultTheme) {
            this.setThematicOnLoad(this.defaultTheme);
        }
    }
    renderBuildings(theme?: string): void {
        const jsonData = buildings["buildings"];
        const container = document.getElementById("pavilion-slide") as HTMLElement;
        if (container) {
            container.innerHTML = '';
            jsonData.forEach((item) => {
                if (theme) {
                    if (item.thematics?.includes(theme)) {
                        this.renderPavHTML(item, container);
                    }
                }
                else {
                    this.renderPavHTML(item, container);
                }
            });
        }
    }
    renderPavHTML(item: any, container: HTMLElement): void {
        const $sliderElement = document.createElement("div");
        const span = document.createElement("span");
        $sliderElement.tabIndex = 1;
        $sliderElement.setAttribute("data-id", item["ref"].toString());
        $sliderElement.setAttribute("class", "slide");
        span.textContent = item.title;
        $sliderElement.onclick = () => {
            if ($sliderElement.classList.contains("slide")) {
                const slides = document.querySelectorAll("#pavilion-slide .slide");
                if ($sliderElement.classList.contains('clicked')) {
                    $sliderElement.classList.remove('clicked');
                    this.selectedBuilding = undefined;
                    this.emit(ThematicComponentEvents.BUILDING_SELECTED, undefined);
                } else {
                    slides.forEach(slide => {
                        slide.classList.remove('clicked');
                    });
                    $sliderElement.classList.add('clicked');
                    this.selectedBuilding = item;
                    this.emit(ThematicComponentEvents.BUILDING_SELECTED, item);
                }
            }
        }
        $sliderElement.appendChild(span);
        container.appendChild($sliderElement);
    }
    selectThematic(theme: any): void {
        const $divElements = document.querySelectorAll('.slide');
        const filteredDivs = Array.from($divElements).filter((element) => {
            const spanElement = element.querySelector('span');
            const textToMatch = getLabel(getLocale().thematics, theme["ref"].toLowerCase());
            return spanElement && spanElement.textContent?.toLowerCase() === textToMatch.toLowerCase();
        });
        filteredDivs.forEach((div) => {
            div.classList.toggle("clicked");
        });
        const $thematicSection = document.getElementsByClassName('thematic-details')[0] as HTMLElement;
        const $thematicsTitle = document.getElementsByClassName('thematic-name')[0] as HTMLElement;
        const $thematicsDescription = document.getElementsByClassName('thematic-desc')[0] as HTMLElement;
        if ($thematicsDescription && this.state.showDescription && $thematicsTitle) {
            $thematicsTitle.innerHTML = getLabel(getLocale().thematics, theme["ref"].toLowerCase())
            $thematicsDescription.innerHTML = getLabel(getLocale().thematicDescription, theme["ref"].toLowerCase()) || theme["description"] || '';
        }
        if($thematicSection){
            $thematicSection.style.display = "flex";
        }
        
        this.emit(ThematicComponentEvents.THEMATIC_SELECTED, `thematic:=${theme["ref"].toLowerCase()}`);
    }
    switchMap(mode:string) {
        this.resetClasses();
        this.defaultTheme = null;
        const $btnAllExhibits = document.getElementById("btnAllExhibits") as HTMLButtonElement;
        const $btnFavorites = document.getElementById("btnFavorites") as HTMLButtonElement;
        switch(mode){
            case 'all':
                $btnAllExhibits.classList.add("active");
                this.renderBuildings();
                this.emit(ThematicComponentEvents.THEMATIC_UNSELECTED, getConfig().map.themes["default"]);
                break;
            case 'favorites':
                $btnFavorites.classList.add("active");
                this.renderBuildings();
                this.emit(ThematicComponentEvents.THEMATIC_UNSELECTED, getConfig().map.themes["favorites"]);
                break;
        }
    }
    resetClasses() {
        const $btnThematic = document.getElementById("btnThematic") as HTMLButtonElement;
        const $thematicSection = document.getElementsByClassName('thematic-details')[0] as HTMLElement;
        const container = document.getElementById("thematicDropdown");
        $btnThematic.classList.remove("active");
        $btnThematic.innerHTML = `${getLocale().messages.select_thematic} <span class="caret"></span>`;
        const $btnAllExhibits = document.getElementById("btnAllExhibits") as HTMLButtonElement;
        const $btnFavorites = document.getElementById("btnFavorites") as HTMLButtonElement;
        if($btnAllExhibits) {
            $btnAllExhibits.classList.remove("active");
        }
        if($btnFavorites) {
            $btnFavorites.classList.remove("active");
        }
        
        if (container) {
            container.querySelectorAll("a").forEach(option => {
                option.classList.remove("selected-thematic");
            });
        }
        if($thematicSection) {
            $thematicSection.style.display = "none";
        }
    }
    setThematicOnLoad(theme: any): void {
        const container = document.getElementById("thematicDropdown");
        const $btnThematic = document.getElementById("btnThematic") as HTMLButtonElement;
        if (container) {
            container.querySelectorAll("a").forEach(option => {
                option.classList.remove("selected-thematic");
            });
            Array.from(container.querySelectorAll('a')).forEach((element) => {
                const textToMatch = getLabel(getLocale().thematics, theme["ref"].toLowerCase());
                if (element && element.textContent?.toLowerCase() === textToMatch.toLowerCase()) {
                    element.classList.add('selected-thematic');
                }
            });
            
        }
        if($btnThematic){
            $btnThematic.innerHTML = `${getLabel(getLocale().thematics, theme["ref"].toLowerCase())} <span class="caret-white"></span>`;
            $btnThematic.classList.add("active");
        }
        this.emit(ThematicComponentEvents.THEMATIC_SELECTED, `thematic:=${theme["ref"].toLowerCase()}`);
    }
    setCTAText(isMobileView:boolean):void {
        const $btnAllExhibits = document.getElementById("btnAllExhibits") as HTMLButtonElement;
        const $btnFavorites = document.getElementById("btnFavorites") as HTMLButtonElement;
        const $btnThematic = document.getElementById("btnThematic") as HTMLButtonElement;
        if($btnAllExhibits) {
            $btnAllExhibits.textContent = isMobileView ? getLocale().messages.allexhibits_mobile : getLocale().messages.allexhibits;
        }
        if($btnFavorites) {
            $btnFavorites.textContent = isMobileView ? getLocale().messages.favorites_mobile : getLocale().messages.favorites;
        }
        if($btnThematic) {
            $btnThematic.innerHTML = `${isMobileView ? getLocale().messages.select_thematic_mobile : getLocale().messages.select_thematic} <span class="caret"></span>`;
        }
    }
}